import { Tooltip, withStyles } from "@material-ui/core";
import React from "react";

const MUITooltip = withStyles((theme) => ({
  tooltip: {
    display: "flex",
    flexDirection: "column",
    width: theme.spacing(100),
    height: theme.spacing(10),
    padding: theme.spacing(1, 3),
    borderRadius: theme.spacing(2),
    backgroundColor:
      theme.palette.type === "light"
        ? theme.palette.secondary.main
        : theme.palette.secondary.tint60,
    color: [theme.palette.white.qrCode, "!important"],
  },
}))(Tooltip);

const UnitPriceTooltip = (props) => {
  const { children, ...rest } = props;
  return <MUITooltip {...rest}>{children}</MUITooltip>;
};

export default UnitPriceTooltip;
